export default {"src":"/_next/static/media/entypo_landline.48b38583.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};